<template>
  <Section :content="trinpodServer" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionTrinpodServer',
  components: {
    Section,
  },
  data() {
    return {
      trinpodServer: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'TrinPod\u2122 Server',
        headlineIcon: 'trinity_secure.png',
        paragraphs: [
          'TrinPod\u2122 Server provides the world\'s first conceptually indexed space-time systems digital twin. It also provides Crosslink, which reads documents for you and links them to your systems with a powerful Search API. TrinPod\u2122 Server runs in the cloud or on premise, and enables you to own and control your data and collaborate globally with the highly secure W3C Solid API.'
        ],
        id: 'trinpod-server',
        image: 'trinpod-server-globe.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
        learnMoreLink: '/trinpod-server'
      },
    }
  }
};
</script>
